var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileham(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23V34C15.5 35.3807 16.6193 36.5 18 36.5H19C20.3807 36.5 21.5 35.3807 21.5 34V23C21.5 22.1716 22.1716 21.5 23 21.5H34C35.3807 21.5 36.5 20.3807 36.5 19V18C36.5 16.6193 35.3807 15.5 34 15.5H23C22.1716 15.5 21.5 14.8284 21.5 14V3C21.5 1.61929 20.3807 0.5 19 0.5H18C16.6193 0.5 15.5 1.61929 15.5 3V14C15.5 14.8284 14.8284 15.5 14 15.5H3C1.61929 15.5 0.5 16.6193 0.5 18V19C0.5 20.3807 1.61929 21.5 3 21.5H14C14.8284 21.5 15.5 22.1716 15.5 23Z",
    fill: "#FFEA32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23V34C15.5 35.3807 16.6193 36.5 18 36.5H19C20.3807 36.5 21.5 35.3807 21.5 34V23C21.5 22.1716 22.1716 21.5 23 21.5H34C35.3807 21.5 36.5 20.3807 36.5 19V18C36.5 16.6193 35.3807 15.5 34 15.5H23C22.1716 15.5 21.5 14.8284 21.5 14V3C21.5 1.61929 20.3807 0.5 19 0.5H18C16.6193 0.5 15.5 1.61929 15.5 3V14C15.5 14.8284 14.8284 15.5 14 15.5H3C1.61929 15.5 0.5 16.6193 0.5 18V19C0.5 20.3807 1.61929 21.5 3 21.5H14C14.8284 21.5 15.5 22.1716 15.5 23Z",
    stroke: "#FFEA32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23V34C15.5 35.3807 16.6193 36.5 18 36.5H19C20.3807 36.5 21.5 35.3807 21.5 34V23C21.5 22.1716 22.1716 21.5 23 21.5H34C35.3807 21.5 36.5 20.3807 36.5 19V18C36.5 16.6193 35.3807 15.5 34 15.5H23C22.1716 15.5 21.5 14.8284 21.5 14V3C21.5 1.61929 20.3807 0.5 19 0.5H18C16.6193 0.5 15.5 1.61929 15.5 3V14C15.5 14.8284 14.8284 15.5 14 15.5H3C1.61929 15.5 0.5 16.6193 0.5 18V19C0.5 20.3807 1.61929 21.5 3 21.5H14C14.8284 21.5 15.5 22.1716 15.5 23Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileham);
export default __webpack_public_path__ + "static/media/mobile ham.f7a3c44f058a42972ad60864d6834c64.svg";
export { ForwardRef as ReactComponent };